export const MINT_ERROR = 'ads.mint.error';
export const MINT_INFO = 'ads.mint.info';
